import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const {
  object, string, node, array,
} = PropTypes;

const TableBox = styled.div`
  flex-direction: column;
  display: flex;
  flex: 1;
  margin-right: 38px;
  
  &:last-of-type {
    margin-right: 0;
    margin-left: 38px;
  }
  
  > p {
    font-weight: 500;
    font-size: 16px;
    line-height: 21px;
    color: #212833;
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    
    > span { flex: none }
    
    > a { color: #F0B90B }
    
    .desc {
      width: 100%;
      display: flex;
      font-size: 14px;
      height: 20px;
      line-height: 20px;
      color: #848E9C;
      
      > b { 
        color: #212833;
        margin: 0 5px;
        font-family: ${({ theme }) => theme.fontIBMRegular};
      }
    }
  }
   
  .vm-table-tr {
    display: flex;
    
    > span {
      flex: none;
      padding: 11px 16px;
      white-space: nowrap;
      
      &:last-of-type {
        text-align: right;
        flex: 1;
      }
    }
  }
    
  .vm-table-head {
    background: rgba(234,236,239,0.3);
    font-size: 14px;
    line-height: 18px;
    color: #848E9C;
    font-family: ${({ theme }) => theme.fontIBMRegular};
    font-weight: normal;
  }
    
  .vm-table-body {
    max-height: 400px;
    overflow: auto;
    border-bottom: 1px solid rgba(234,236,239,0.6);
    font-size: 12px;
    line-height: 16px;
    color: #212833;
    
    &::-webkit-scrollbar { width: 4px;}
    &::-webkit-scrollbar-track { border-radius: 100px; }
    
    .vm-table-tr {
      font-weight: bold;
      border-bottom: 1px solid rgba(234,236,239,0.6);
      
      &:last-of-type {
        border-bottom: none;
      }
      
      &[data-active=true] {
        background: rgba(234,236,239,0.3);
        color: #F0B90B;
      }
    }
  }
    
  .pre-login {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px 20px;
    
    .no-icon {
      width: 104px;
      height: 104px;
      background: url(${require('../images/frame.png')}) no-repeat center/100%;
    }
    
    > p { 
      margin: 20px auto 0;
      font-size: 16px;
      height: 22px;
      line-height: 22px;
      
      > a { color: #F0B90B; }   
    }
  }
  
  @media screen and (max-width: 414px) {
    flex: none;
    width: 100%;
    margin-top: 38px;
    margin-right: 0 !important;
    margin-left: 0 !important;
    
    > p .desc {
      height: auto;
    }
    
    .pre-login {
      .no-icon {
        width: 80px;
        height: 80px;
      }
    }
  }
`;

const VmTable = ({
  title, extra, desc, trList, children,
}) => (
  <TableBox>
    <p>
      <span>{title}</span>
      {extra || null}
      {desc || null}
    </p>
    <div className="vm-table-head">
      <div className="vm-table-tr">
        {trList.map((tr, key) => <span key={key}>{tr}</span>)}
      </div>
    </div>
    {children}
  </TableBox>
);

VmTable.propTypes = {
  title: string,
  extra: node,
  desc: node,
  trList: array,
  i18n: object,
  locale: string,
  children: node,
};

export default VmTable;
